import { LogService } from "@/services/LogService";
import { SearchItem, SnackbarStatus } from "@/types";
import { useSnackbarStore } from "@/pinia/snackbar";

/**
 * Provides functions to manage snackbar that is implemented in App.vue
 */
export class SnackbarService {
  private static snackbarStore: ReturnType<typeof useSnackbarStore>;
  private static snackbar: SnackbarStatus;

  private static _initialized = false;
  // To reset Vuetify timeout and clear old snackbar, timeout needs to change.
  // Increment default timeout to avoid new snackbar being ignored.
  private static _timeoutAdjustment = 0;

  static _initialize(): void {
    if (this._initialized) {
      LogService.warn(
        "SnackbarService._initialize: service is already initialized."
      );
      return;
    }
    LogService.debug("Initializing SnackbarService.");

    this.snackbarStore = useSnackbarStore();
    this.snackbar = this.snackbarStore.snackbar;

    this._initialized = true;
    LogService.info("SnackbarService is initialized.");
  }

  public static displaySnackbar(
    message: string,
    color = "error",
    timeout = 3000,
    searchItem: SearchItem | null = null
  ): void {
    if (!this._initialized) {
      LogService.warn(
        "SnackbarService.displaySnackbar is called before being initialized."
      );
      return;
    }
    if (this.snackbar.state) {
      this._timeoutAdjustment++;
      LogService.debug(
        `SnackbarService: setting _timeoutAdjustment to ${this._timeoutAdjustment}.`
      );
    } else {
      this._timeoutAdjustment = 0;
    }
    // Update/clear the snackbar search item as needed so the select folders button does not appear
    this.snackbar.itemBeingMoved = searchItem;
    this.snackbar.color = color;
    this.snackbar.timeout = timeout + this._timeoutAdjustment;
    this.snackbar.message = message;
    this.snackbar.state = true;
  }

  public static closeSnackbar(): void {
    this.snackbar.state = false;
  }
}
